/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Su_TrustInputs */

const en_funnel_su_trust = /** @type {(inputs: Funnel_Su_TrustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trusted by 50,000+ listeners`)
};

const es_funnel_su_trust = /** @type {(inputs: Funnel_Su_TrustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con la confianza de más de 50.000 oyentes`)
};

/**
* | output |
* | --- |
* | "Trusted by 50,000+ listeners" |
*
* @param {Funnel_Su_TrustInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_su_trust = /** @type {((inputs?: Funnel_Su_TrustInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Su_TrustInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_su_trust(inputs)
	return en_funnel_su_trust(inputs)
});